const inputGridColsDesktop = [
  'md:col-span-1',
  'md:col-span-2',
  'md:col-span-3',
  'md:col-span-4',
  'md:col-span-5',
  'md:col-span-6',
  'md:col-span-7',
  'md:col-span-8',
  'md:col-span-9',
  'md:col-span-10',
  'md:col-span-11',
  'md:col-span-12',
];

export const getInputGrid = (layoutGridColumnSpan?: number | string) => {
  layoutGridColumnSpan = Number(layoutGridColumnSpan);
  if (!layoutGridColumnSpan) {
    return inputGridColsDesktop[11];
  }
  return `col-span-12 ${
    inputGridColsDesktop[layoutGridColumnSpan - 1] || inputGridColsDesktop[11]
  }`;
};

export default getInputGrid;
